module.exports = __webpack_public_path__ + "static/assets/445e1cd3c7bdfcf00df69be73de214b5.png";